<template>
  <Content title="我们的服务">
    <div class="row">
      <div class="col-sm bg-white service-item d-flex align-items-center">
        <div class="service-icon-wrapper d-flex justify-content-center align-items-center">
          <div class="service-icon service-icon-service"></div>
        </div>
        <span class="service-desc">7*24小时客服服务，便捷退改</span>
      </div>
      <div class="col-sm bg-white service-item d-flex align-items-center">
        <div class="service-icon-wrapper d-flex justify-content-center align-items-center">
          <div class="service-icon service-icon-airline"></div>
        </div>
        <span class="service-desc">多家航司直连产品，价格透明</span>
      </div>
    </div>
    <div class="row">
      <div class="col-sm bg-white service-item d-flex align-items-center">
        <div class="service-icon-wrapper d-flex justify-content-center align-items-center">
          <div class="service-icon service-icon-product"></div>
        </div>
        <span class="service-desc">产品涉及国内/外机票、国内/外酒店、火车票、用车、签证等</span>
      </div>
      <div class="col-sm bg-white service-item d-flex align-items-center">
        <div class="service-icon-wrapper d-flex justify-content-center align-items-center">
          <div class="service-icon service-icon-integral"></div>
        </div>
        <div class="service-desc">
          <div>根据实际销售金额获取相应积分</div>
          <div>积分兑换礼品、机票</div>
        </div>
      </div>
    </div>
  </Content>

  <Content
    title="我们的动力-来自客户的认同"
    class="bg-white sk-motivation"
    :titleStyle="{ color: '#fff' }"
  >
    <div class="d-flex wrapper">
      <div class="motivation-img">
        <img height="550" src="/images/airplane-passenger@2x.png" alt="" />
      </div>
      <div class="trapezoid">
        <div id="customerStoryCarousel" class="carousel slide" data-ride="carousel">
          <ol class="carousel-indicators">
            <li data-target="#customerStoryCarousel" data-slide-to="0" class="active"></li>
            <li data-target="#customerStoryCarousel" data-slide-to="1"></li>
            <li data-target="#customerStoryCarousel" data-slide-to="2"></li>
          </ol>
          <div class="carousel-inner">
            <div class="carousel-item active">
              <div>
                <div class="mark"></div>
                <h5 class="text-white customer-name">客户张先生：</h5>
                <div class="text-white">
                  由于乘机人是位老人家，在预认转账时，不知道操作微信，客服在电话中一步步讲解，用时26分钟成功帮客户预订并支付成功，并获得客户高度表扬
                </div>
              </div>
            </div>
            <div class="carousel-item">
              <div>
                <div class="mark"></div>
                <h5 class="text-white customer-name">客户李阿姨：</h5>
                <div class="text-white">
                  第一次联系我司预订机票，整个过程中客服不厌其烦，给客户讲解机票相关知识，最终成功出4张机票，同时主动提出出票后帮客户提前选座，服务时间累计长达2小时，客户对客服服务非常满意
                </div>
              </div>
            </div>
            <div class="carousel-item">
              <div>
                <div class="mark"></div>
                <h5 class="text-white customer-name">客户贾主任：</h5>
                <div class="text-white">
                  由于疫情影响，该客户工作需要必须预订指定日期南充至深圳航班，由于当天无票状态，该坐席了解到客户需求，不停协助查询刷票，最终成功帮客户预订成功，对此客户非常感动，表示在其他网上都不能购买到，联系到特航就能解决出行，非常感恩我们，并发红包表达心意
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrapper-normal">
        <div id="customerStoryCarousel" class="carousel slide" data-ride="carousel">
          <ol class="carousel-indicators">
            <li data-target="#customerStoryCarousel" data-slide-to="0" class="active"></li>
            <li data-target="#customerStoryCarousel" data-slide-to="1"></li>
            <li data-target="#customerStoryCarousel" data-slide-to="2"></li>
          </ol>
          <div class="carousel-inner">
            <div class="carousel-item active">
              <div>
                <div class="mark"></div>
                <h5 class="text-white customer-name">客户张先生：</h5>
                <div class="text-white">
                  由于乘机人是位老人家，在预认转账时，不知道操作微信，客服在电话中一步步讲解，用时26分钟成功帮客户预订并支付成功，并获得客户高度表扬
                </div>
              </div>
            </div>
            <div class="carousel-item">
              <div>
                <div class="mark"></div>
                <h5 class="text-white customer-name">客户李阿姨：</h5>
                <div class="text-white">
                  第一次联系我司预订机票，整个过程中客服不厌其烦，给客户讲解机票相关知识，最终成功出4张机票，同时主动提出出票后帮客户提前选座，服务时间累计长达2小时，客户对客服服务非常满意
                </div>
              </div>
            </div>
            <div class="carousel-item">
              <div>
                <div class="mark"></div>
                <h5 class="text-white customer-name">客户贾主任：</h5>
                <div class="text-white">
                  由于疫情影响，该客户工作需要必须预订指定日期南充至深圳航班，由于当天无票状态，该坐席了解到客户需求，不停协助查询刷票，最终成功帮客户预订成功，对此客户非常感动，表示在其他网上都不能购买到，联系到特航就能解决出行，非常感恩我们，并发红包表达心意
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Content>
</template>
<script>
import Content from '@/shared/components/content.vue'
export default {
  name: 'MobileContent',
  components: { Content },
  setup() {},
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
}

.trapezoid {
  border-bottom: 526px solid #5285fb;
  border-left: 150px solid transparent;
  border-right: 0 solid transparent;
  height: 0;
  width: 844px;
  position: absolute;
  right: 0;
  top: 88px;
}

.wrapper-normal {
  display: none;
}

#customerStoryCarousel {
  height: 526px;
  padding-top: 104px;
  padding-right: 114px;
  padding-left: 114px;
}

.mark {
  margin-bottom: 28px;
  width: 64px;
}

.customer-name {
  font-size: 26px;
  margin-bottom: 50px;
}

.service-item {
  margin-right: 32px;
  margin-bottom: 30px;
  padding-top: 32px;
  padding-bottom: 32px;
  padding-left: 56px;
  padding-right: 56px;
  transition: all 0.3s ease-out;
}

.service-icon {
  height: 70px;
  width: 70px;
  background-size: cover;
  background-repeat: no-repeat;
}

.service-icon-service {
  background-image: url('/images/sk-service.svg');
}

.service-icon-airline {
  height: 60px;
  background-image: url('/images/sk-airline.svg');
}

.service-icon-product {
  width: 55px;
  height: 70px;
  background-image: url('/images/sk-product.svg');
}

.service-icon-integral {
  background-image: url('/images/sk-integral.svg');
}

.service-icon-wrapper {
  width: 130px;
  height: 130px;
  border-radius: 50%;
  background-color: #f7f7f9;
  margin-right: 40px;
  flex: none;
  transition: all 0.3s ease-out;
}

.service-desc {
  color: #333333;
  font-size: 18px;
}

.service-item:hover {
  box-shadow: 0px 3px 20px 0px rgba(0, 0, 0, 0.22);
}

.service-item:hover .service-icon-wrapper {
  background-color: #4b7ef6;
}

.service-item:hover .service-icon-service {
  background-image: url('/images/sk-service-light.svg');
}

.service-item:hover .service-icon-airline {
  background-image: url('/images/sk-airline-light.svg');
}

.service-item:hover .service-icon-product {
  background-image: url('/images/sk-product-light.svg');
}

.service-item:hover .service-icon-integral {
  background-image: url('/images/sk-integral-light.svg');
}

@media (min-width: 1420px) {
  .sk-motivation {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .sk-motivation .wrapper {
    width: 1420px;
  }
}

@media (max-width: 768px) {
  .banner-sk {
    height: 217px;
    background-image: url('/images/mobile/sk-banner.png');
  }

  .motivation-img {
    display: none;
  }

  .service-item {
    margin-right: 20px;
    margin-left: 20px;
    margin-bottom: 10px;
    padding: 16px 19px;
    box-shadow: 0px 2px 23px 0px rgba(230, 230, 230, 1);
    border-radius: 5px;
  }

  .service-desc {
    font-size: 14px;
  }

  .service-icon-wrapper {
    width: 65px;
    height: 65px;
  }

  .service-icon {
    width: 35px;
    height: 35px;
  }

  .service-icon-product {
    width: 28px;
  }

  .wrapper {
    position: static;
  }

  .trapezoid {
    display: none;
  }

  .wrapper-normal {
    display: block;
  }

  #customerStoryCarousel {
    height: auto;
    min-height: 320px;
    padding: 35px;
  }

  .sk-motivation {
    background-color: #5285fb !important;
    padding-top: 35px;
  }

  .motivation-title {
    font-size: 24px;
    color: #f7f7f9;
    margin-bottom: 0;
  }

  .carousel-indicators li.active {
    background-color: #ffffff;
  }

  .customer-name {
    font-size: 16px;
    font-weight: normal;
    margin-bottom: 24px;
  }
}
</style>
